module.exports = __webpack_public_path__ + "img/shouye_jishi@2x.84836c1d.png";